import {getUser} from '@gaia/hooks/useUser';
import amplitude from 'amplitude-js';
import trackAnalytics, {analyticsInitialized, isOptedOut} from './trackAnalytics';

export type RevenueAnalyticsEvent = AnalyticsEvent & {
    revenue: number;
    currencyCode: number;
    productId: number;
    plan: string;
};

export default async function trackRevenueAnalytics<T extends RevenueAnalyticsEvent>(
    name: T['analyticsEventName'],
    properties: Omit<T, 'analyticsEventName'>
) {
    await analyticsInitialized;

    if (isOptedOut(await getUser())) return;

    if (properties && properties.revenue && properties.productId) {
        const revenue = new amplitude.Revenue()
            .setProductId(String(properties.productId))
            .setPrice(properties.revenue)
            .setQuantity(1);

        amplitude.getInstance().logRevenueV2(revenue);
    }
    trackAnalytics(name, properties);
}
